import { render, staticRenderFns } from "./MaterialCarts.vue?vue&type=template&id=42d1a5b9&scoped=true"
import script from "./MaterialCarts.vue?vue&type=script&lang=js"
export * from "./MaterialCarts.vue?vue&type=script&lang=js"
import style0 from "./MaterialCarts.vue?vue&type=style&index=0&id=42d1a5b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d1a5b9",
  null
  
)

export default component.exports